let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files

  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/product-form.js?v=56043074768287964941772021144");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/shopflo.bundle.js?v=26043");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/pubsub.js?v=26034608122085135261776334463");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/cart-notification.js?v=133508293167896966491760006770");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/constants.js?v=132983761750457495441760006767");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/cart.js?v=95316439595850377071760006770");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/cart-drawer.js?v=2239547715108954751772021138");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-scroll-tab.js?v=110537738839353943101760006769");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/collapsable-combo-section.js?v=62496326040323439081771240526");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-available-offers.js?v=26043");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-details.js?v=114717867829024831851776327961");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-recom-prods.js?v=26043");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/edd-section.js?v=100119633110064442781760006769");
  

  
  
    

  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/collapsible-content.css?v=69792250384829907791771240527");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-accordion.css?v=130141578229643766071779085701");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-social-reviews.css?v=74717896916299017681760006769");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-available-offers.css?v=112077318425957018091760006770"); 
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-scroll-tab.css?v=116609938375906285541773299872");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/new_serums_section.css?v=169911888615296355471778136847");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/sunscreen-quiz-pdp.css?v=150892412449710366031760006769");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/new-details-collapsable.css?v=21783054330784661661760006768");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-color-swatch.css?v=44657734777189145271772876698");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/all.min.css?v=36347114306294163891760006767");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-price.css?v=70172745017360139101760006770");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-card.css?v=90531592475021317501776334462");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-cart.css?v=49529066954642232561760006766");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-mega-menu.css?v=3343104478291901121778136842");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-totals.css?v=59014315448263284001771240528");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-cart-drawer.css?v=14654014436926053241780735378");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-discounts.css?v=152760482443307489271760006768");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/searchtap.css?v=72127222885983381071764847290");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-list-menu.css?v=151968516119678728991760006769");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-search.css?v=165164710990765432851760006768");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-menu-drawer.css?v=20646116693146970981760006767");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-cart-notification.css?v=54116361853792938221760006770");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-cart-items.css?v=47901327362710772261760006769");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-collection-hero.css?v=150137544140055157131760006767");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/quick-add.css?v=66647833350618835731760006766");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-show-more.css?v=139536189637226996221760006768");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-swatch-input.css?v=61683592951238328641760006769");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/component-swatch.css?v=68619770617697936771760006770");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/collapsable-combo-section.css?v=16640933633868879741760006766");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-feature-svg.css?v=107811230276467158871760006767");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/npdp-recom-prods.css?v=42018924242700305821768539502");
  // loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/edd-section.css?v=156305196500708653761780921954");


   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/details-modal.js?v=119528565511025453401760006770");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/36/assets/details-disclosure.js?v=13653116266235556501760006769");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
